export const CompanyConstant = {
    GET_COMPANYLIST: 'GET_COMPANYLIST',
    GET_COMPANY: 'GET_COMPANY',
    UPDATE_COMPANYINFO: 'UPDATE_COMPANYINFO',
    ADD_COMPANYINFO: 'ADD_COMPANYINFO',
    DELETE_COMPANY: 'DELETE_COMPANY',
    CLEAR_UPDATERES: 'CLEAR_UPDATERES',
    ERROR: 'ERROR',
};